// extracted by mini-css-extract-plugin
module.exports = {"result-container":"styles_result-container__eRrZT","incard-title":"styles_incard-title__30EQh","tab-font":"styles_tab-font__3khRs"};